import { useContext } from 'react'

import { WizardContext } from '../context'

export const useWizardContext = () => {
  const context = useContext(WizardContext)

  if (!context) throw new Error('context must be in a context wizard provider')

  return context
}
